import { Duration } from 'luxon';

export const decimalToDuration = (amount: number) => {
  if (typeof amount !== 'number' || isNaN(amount)) {
    console.error(`Invalid amount: ${amount}`);
    amount = 0;
  }

  let hours = Math.floor(amount);
  let minutes = Math.round((amount - hours) * 60);

  // Normalize overflow (e.g. 2.999 → 3:00)
  if (minutes === 60) {
    hours += 1;
    minutes = 0;
  }

  return Duration.fromObject({ hours, minutes });
};
